import React, { useState, useEffect } from "react";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import AddIcon from "@mui/icons-material/Add";
import Pagination from "../../components/Pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import loader from "../../assets/loader.webp";
import AddSubcategory from "./AddSubcategory";
import EditSubcategory from "./EditSubcategory";
import ConfirmModal from "../../components/ConfirmModal";
import { fetchData, deleteData, getDataById } from "../../utility/adminApi";

function SubCategory() {
  const [subcategoryData, setSubcategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addtab, setAddtab] = useState(false);
  const [edittab, setEdittab] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [singleData, setSingleData] = useState({});
  const [subcatIdToDelete, setSubcatIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchSubcategories = async (page) => {
    const response = await fetchData("sub_categories", currentPage, searchData);
    setSubcategoryData(response?.data?.data || []);

    setTotalPage(response?.data?.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  useEffect(() => {
    fetchSubcategories(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  useEffect(() => {
    setCurrentPage(1);
    fetchSubcategories(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  const handleCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleAdd = () => {
    setAddtab(true);
    setEdittab(false);
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("sub_categories/show/", id);
    setSingleData(response?.data?.data);
    if (setEditTab) {
      setEdittab(true);
    } else {
      // setViewFile(true)
    }
  };

  const handleDelete = (id) => {
    setSubcatIdToDelete(id);
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleConfirmDelete = async () => {
    await deleteData(
      "sub_categories/delete/",
      subcatIdToDelete
    );

    fetchSubcategories(currentPage); //
    setIsModalOpen(false);
  };

  if (isLoading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className=" w-10 lg:w-20 " />
      </div>
    );
  }

  return (
    <div className=" flex lg:overflow-y-hidden ">
      {/* Header */}

      <div className="flex flex-col gap-4 w-full ">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            {" "}
            <ClearAllIcon />
            <h3 className="text-2xl font-semibold">Sub-Category</h3>
          </div>

          <div className="flex flex-row gap-4 flex-wrap">
            <button
              onClick={() => {
                handleAdd();
              }}
              className="px-4 py-3 text-white rounded-lg bg-blue-500"
            >
              Add New Sub-Category <AddIcon />
            </button>
          </div>
        </div>

        {addtab && !edittab && (
          <AddSubcategory
            setIsLoading={setIsLoading}
            setAddtab={setAddtab}
            fetchCategories={fetchSubcategories}
            currentPage={currentPage}
          />
        )}

        {edittab && !addtab && (
          <EditSubcategory
            singleData={singleData}
            setSingleData={setSingleData}
            setEdittab={setEdittab}
            setLoading={setIsLoading}
            currentPage={currentPage}
            fetchSubcategories={fetchSubcategories}
          />
        )}
        {!edittab && !addtab && (
          <div className=" bg-white flex flex-col lg:justify-normal w-full lg:gap-4 overflow-x-auto items-center py-6 px-8">
            <div className="flex  w-full">
              <div>
                {/* Consider resarching for MUI UI search bar  */}
                <input
                  placeholder="Search for"
                  type="text"
                  name="cat_name"
                  // id="email"
                  value={searchData}
                  onChange={handleChange}
                  className="border-2 border-gray-400 w-60 p-2 px-6"
                />
              </div>
            </div>

            <div className="w-full">
              <table className="min-w-full bg-white border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-4 border-b border-gray-300">NAME</th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      CATEGORY
                    </th>

                    <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                      ACTIONS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {subcategoryData?.map((item) => (
                    <tr
                      key={item?.id}
                      className="hover:bg-gray-100 border-b border-gray-300"
                    >
                      <td className="py-2 px-4 text-center text-wrap">
                        {item?.sub_cat_name}
                      </td>

                      <td className="py-2 px-4 text-center text-wrap">
                        {item?.category?.cat_name}
                      </td>

                      <td className="py-2 px-4 flex justify-center gap-3">
                        <EditIcon
                          onClick={() => handleSingleFile(item.id, true)}
                          className="text-blue-500 cursor-pointer"
                        />
                        {/* <VisibilityIcon className="text-yellow-400" /> */}
                        <DeleteIcon
                          onClick={() => handleDelete(item.id)}
                          className="text-red-500 cursor-pointer"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Pagination
                onPageChange={handleCurrentPage}
                totalPage={totalPage}
                currentPage={currentPage}
                setIsNextLoading={setIsNextLoading}
                setIsPrevLoading={setIsPrevLoading}
                isPrevLoading={isPrevLoading}
                isNextLoading={isNextLoading}
              />
            </div>
          </div>
        )}
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Delete"
        text2="Are you sure you want to delete the sub-category?"
      />
    </div>
  );
}

export default SubCategory;
